import { useVariantSelection } from '@/hooks/useVariantSelection';
import { ProductVariantCopy } from '@/lib/contentful';
import { ShopifyVariant } from '@/lib/shopify';
import { getVariantTranslation } from '@/utils/getVariantTranslation';
import classNames from 'classnames';
import { Dispatch, FC, SetStateAction } from 'react';
import slash from './assets/variant-slash.svg';
import Image from 'next/image';
import { TypeProduct } from '@/core/generated-types';

export interface VariantCirclesProps {
  variants: ShopifyVariant[];
  selectedVariant: ShopifyVariant;
  cb?: Dispatch<SetStateAction<ShopifyVariant>>;
  productVariantsCopy: ProductVariantCopy | null;
  product: TypeProduct;
}

export const VariantCircles: FC<VariantCirclesProps> = ({
  productVariantsCopy,
  selectedVariant,
  variants,
  cb,
  product,
}) => {
  const { handleVariantClick } = useVariantSelection(cb);

  const label =
    product.fields.variantLabel ||
    getVariantTranslation(productVariantsCopy, 'Style');

  const title = getVariantTranslation(
    productVariantsCopy,
    selectedVariant.title,
  );

  return (
    <div className="mb-4" data-testid="variant-container">
      <p className="mb-1 text-sm font-bold">
        <span data-testid="variant-label">{label}</span>:&nbsp;
        {selectedVariant && title}
      </p>
      <div className="flex gap-2 flex-wrap">
        {variants.map((v: ShopifyVariant) => {
          const isSelected = v.id === selectedVariant.id;
          return (
            <div
              key={v.id}
              onClick={() => handleVariantClick(v)}
              style={{
                backgroundImage: `url(${v.image.url})`,
              }}
              data-testid="variant-circle"
              className={classNames(
                'h-14 w-14 flex-none border border-grey-light relative rounded-full bg-center bg-cover bg-no-repeat cursor-pointer overflow-hidden',
                {
                  'outline outline-1 outline-blue-deep border-blue-deep':
                    isSelected,
                },
              )}
            >
              {!v.availableForSale && (
                <Image
                  src={slash}
                  alt="variant slash"
                  className="h-full absolute top-0 left-[4.5px]"
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
